import React from 'react'

import Box from '@mui/material/Box'

const FormConditionalSubgroup = props => {
  const { children, condition, ...other } = props

  return (
    <Box
      bgcolor='grey.100'
      px={3}
      pb={2}
      display={condition ? 'block' : 'none'}
      {...other}
    >
      {children}
    </Box>
  )
}

export default FormConditionalSubgroup
